module.exports = __webpack_public_path__ + "media/images/help/about/heading-mv-341f8ec5b29aef9a064beb058eb9e683.svg";